export default __webpack_public_path__ + "static/media/Instagram.9825459f.svg";